import { createSlice } from '@reduxjs/toolkit';

// const initialState = {
//   user: null,
//   response: null,
//   loading: false,
//   error: null,
//   callTimes: 0,
//   message: '',
//   data: []
// }
const initialState = {
  list: [], // ✅ all media
  single: null, // ✅ one media
  loading: false,
  error: null
};

// export const mediaSlice = createSlice({
//   name: 'mediaSliceName',
//   initialState,
//   reducers: {
//     addMedia: () => {

//     },
//     getMedia: () => {

//     },
//     getOneMedia: () => {

//     },

//     successMedia: (state, action) => {
//       console.log(state)
//       state.data = action.payload
//   },
//     removeMedia: () => {
//     },
//     updateMedia: () => {
//     },
//     emptyCart: (state, action) => {
//       state.value += action.payload
//     },
//   },
// })

// Action creators are generated for each case reducer function

export const mediaSlice = createSlice({
  name: 'media',
  initialState,
  reducers: {
    addMedia: () => {},
    getMedia: () => {},
    getOneMedia: () => {},
    removeMedia: () => {},
    updateMedia: () => {},

    successMediaList: (state, action) => {
      state.list = action.payload;
    },

    successSingleMedia: (state, action) => {
      state.single = action.payload;
    }
  }
});

// export const { addMedia, removeMedia, updateMedia, getMedia, successMedia, getOneMedia } = mediaSlice.actions

export const {
  addMedia,
  removeMedia,
  updateMedia,
  getMedia,
  getOneMedia,
  successMediaList, // ✅ ADD THIS
  successSingleMedia // ✅ ADD THIS
} = mediaSlice.actions;

export default mediaSlice.reducer;
